import { ROUTES } from "../constants";
import { apiRequest } from "./api.client";

export { ApiError as NoteApiError } from "./api.errors";

// ── Types ──────────────────────────────────────────────────────────────────────

export type NoteEditPolicy = "primary_doctor_only" | "any_clinic_doctor";

export interface NoteResponse {
  note_id: string;
  entry_id: string;
  patient_id: string;
  visit_id?: string | null;
  author_doctor_id: string;
  author_name: string;
  body: string;
  entry_created_at: string;
  created_at: string;
  is_deleted: boolean;
}

export interface NoteCreate {
  body: string;
  visit_id?: string;
}

export interface NoteUpdate {
  body: string;
  base_note_id: string;
}

export interface NoteHistoryResponse {
  entry_id: string;
  versions: NoteResponse[];
}

export interface NoteEditPolicyResponse {
  note_edit_policy: NoteEditPolicy;
}

// ── API ────────────────────────────────────────────────────────────────────────

export const NotesAPI = {
  list(patientId: string): Promise<NoteResponse[]> {
    return apiRequest<NoteResponse[]>(ROUTES.PATIENT_NOTES(patientId));
  },

  add(patientId: string, data: NoteCreate): Promise<NoteResponse> {
    return apiRequest<NoteResponse>(ROUTES.PATIENT_NOTES(patientId), {
      method: "POST",
      body: JSON.stringify(data),
    });
  },

  edit(patientId: string, entryId: string, data: NoteUpdate): Promise<NoteResponse> {
    return apiRequest<NoteResponse>(ROUTES.PATIENT_NOTE(patientId, entryId), {
      method: "PUT",
      body: JSON.stringify(data),
    });
  },

  remove(patientId: string, entryId: string): Promise<null> {
    return apiRequest<null>(ROUTES.PATIENT_NOTE(patientId, entryId), { method: "DELETE" });
  },

  history(patientId: string, entryId: string): Promise<NoteHistoryResponse> {
    return apiRequest<NoteHistoryResponse>(ROUTES.PATIENT_NOTE_HISTORY(patientId, entryId));
  },

  getEditPolicy(): Promise<NoteEditPolicyResponse> {
    return apiRequest<NoteEditPolicyResponse>(ROUTES.CLINIC_NOTE_EDIT_POLICY);
  },

  updateEditPolicy(policy: NoteEditPolicy): Promise<NoteEditPolicyResponse> {
    return apiRequest<NoteEditPolicyResponse>(ROUTES.CLINIC_NOTE_EDIT_POLICY, {
      method: "PUT",
      body: JSON.stringify({ note_edit_policy: policy }),
    });
  },
};
